import { History } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../auth';
import { AuditList } from '../components/AuditList';
import { Topbar } from '../components/Layout';
import { useI18n } from '../i18n';

/** Administrators' view of everything recorded in the audit log. */
export function AuditPage() {
  const { t } = useI18n();
  const { can } = useAuth();
  if (!can('audit.view')) return <Navigate to="/" replace />;
  return (
    <>
      <Topbar title={t('audit.title')} />
      <div className="card">
        <div className="card-head">
          <div className="tile">
            <History />
          </div>
          <div className="grow">
            <h2>{t('audit.title')}</h2>
            <div className="sub">{t('audit.retention')}</div>
          </div>
        </div>
        <div className="card-pad" style={{ paddingTop: 0 }}>
          <AuditList load={(p) => api.audit(p)} showSurvey />
        </div>
      </div>
    </>
  );
}
